export default import.meta.ROLLDOWN_FILE_URL_7aHwf2tpT9645N1YtxgDqg